import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './historyDialog.scss';
import { useAuth } from '@/lib/auth'
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { ReactComponent as Statusicon } from '@/assets/steam/funnel-frame.svg';
import { ReactComponent as LastCoverageIcon } from '@/assets/steam/last-coverage.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/date-frame.svg';
import { ReactComponent as Coverageicon } from '@/assets/steam/coverage-frame.svg';
import { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import { ReactComponent as ProductIconWithBg } from '@/assets/steam/product-with-bg.svg';
import Utils from '@/utils/util';
import { useGetUsersList } from '@/features/users/api/getProducts';
import { User } from '@/types';
import { useGetFunnelStagess } from '../api/getStages';
import { useGetProductGroupList, useGetProductList } from '@/features/product/api/getProduct';
import { Product } from '@/features/product/types/indes';
import FullHistoryComponent from './fullHistoryComponent';

const HistoryDialog: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    title?: string;
    historyDetailss?: any;
    funnetType?: any;
    selectedFunnel?: any;
    usersListData:any;
    productList:any;
}> = ({ open, onClose, onConfirm, title, historyDetailss, funnetType, selectedFunnel,usersListData , productList}) => {
    const { user } = useAuth();
    const useGetUsersMutation = useGetUsersList();
    const [usersList, setUsersList] = useState<User[]>([]);
    const useGetFunnelStagessMutation = useGetFunnelStagess();
    const [funnelStages, setFuneelStages] = useState<[]>([]);
    const [productsGroupList, setAllProductsGroupList] = useState<any[]>([]);
    const useGetProductMutation = useGetProductList();
    const useGetProductGroupMutation = useGetProductGroupList();

    useEffect(() => {
        //getUsersList(1);
       // getProductList();
        if (selectedFunnel) {
            getProductsGroupList();
        }
        if (funnetType) {
            getFunnelStages(funnetType);
        }
    }, [funnetType])

    useEffect(()=>{
        setUsersList(usersListData ? usersListData : []);
    },[usersListData])


    const getProductList = async () => {
        const res = await useGetProductMutation.mutateAsync({
            page: 1,
            perPage: 100,
            search: '',
            filter: '',
        });

       // setAllProductsList(res.list)

    };

    const getProductsGroupList = async () => {
        const res = await useGetProductGroupMutation.mutateAsync({
            funnelId: selectedFunnel.id
        });

        setAllProductsGroupList(res.productGroupData)

    };
    const getFunnelStages = async (id: any) => {
        const res = await useGetFunnelStagessMutation.mutateAsync({
            id: Number(id)
        });

        if (res) {
            setFuneelStages(res.list)
        }
    }

    const getUsersList = async (pageIndex: number, reset = false, filter?: any) => {
        const res = await useGetUsersMutation.mutateAsync({
            page: pageIndex,
            perPage: 500,
            search: '',
            filter: { 'rolesId': [1, 2, 3, 4] },
        });
        setUsersList(res.list);

    };

    const getUserName = (userId: any) => {
        const data: any = usersList.filter((item: any) => Number(item.id) === Number(userId))
        if (data && data.length > 0) {
            return data[0].name
        } else {
            return selectedFunnel?.assignedUser?.name
        }

    }


    const getStageName = (stageId: any) => {
        const data: any = funnelStages.filter((item: any) => Number(item.id) === Number(stageId))
        if (data && data.length > 0) {
            return data[0].name
        } else {
            return 'Initial Sampling'
        }

    }

    const getProductName = (id: any) => {
        const getProductName = productsGroupList && productsGroupList.length > 0 && productsGroupList.filter((item: any) => Number(item.id) === Number(id));
        if (getProductName && getProductName.length > 0) {
            return getProductName[0].product.name
        } else {
            return ''
        }

    }


    const getTitleName = (item: any, fieldName: string) => {

        if (item.tableName === 'funnel') {
            if (item.fieldName === 'dealSize') {
                return 'Funnel dealsize updated'
            } else if (item.fieldName === "followUpDate") {
                return 'Funnel follow up date updated'
            } else if (item.fieldName === "coverageDate") {
                return 'Funnel coverage date updated'
            } else if (item.fieldName === "stageId") {
                return 'Funnel state updated'
            } else if (item.fieldName === "comments") {
                return 'Coverage details updated'
            } else {
                return 'Deal size updated'
            }
        } else if (item.tableName === "product_group") {
            return ''
        } else if (item.tableName === "contact") {
            return 'Contacts updated'
        }

    }


    const getProductDeletedStatus = (id: any) => {
        const getProductdeleted = productsGroupList && productsGroupList.length > 0 && productsGroupList.filter((item: any) => item.id === id);
        if (getProductdeleted && getProductdeleted.length > 0 && getProductdeleted[0].deletedAt) {
            return true
        } else {
            return false
        }
    }



    const getDeletedProductName = (id: any) => {
        const getProductName = productsGroupList && productsGroupList.length > 0 && productsGroupList.filter((item: any) => item.id === id);
        if (getProductName && getProductName.length > 0) {
            return getProductName[0].product.name
        } else {
            return ''
        }
    }

    const getProductClassNames = (classIds: number[]) => {
        const classNames: string[] = [];

        classIds?.forEach((classId) => {
            productList?.forEach((product: any) => {
                product.subject?.forEach((subject: any) => {
                    subject.classes?.forEach((classItem: any) => {
                        if (parseInt(classItem.id) === Number(classId)) {
                            classNames.push(classItem.name);
                        }
                    });
                });
            });
        });
        return classNames.join(', ');
    };

    const getProductSubjectNames = (subjectIds: number[]) => {
        const classNames: string[] = [];

        subjectIds?.forEach((subjectId) => {
            productList?.forEach((product: any) => {
                product.subject?.forEach((subject: any) => {
                    if (parseInt(subject.id) === Number(subjectId)) {
                        classNames.push(subject.name);
                    }
                });
            });
        });
        return classNames.join(', ');

    };


    const getProductDetails = (details: any) => {
        if (!details || details.docs.length === 0) return null;

        // Group the items by pk
        const groupedByPk = details.docs.reduce((acc: any, item: any) => {
            if (!acc[item.pk]) {
                acc[item.pk] = [];
            }
            acc[item.pk].push(item);
            return acc;
        }, {});

        return Object.keys(groupedByPk).map((pk) => {
            const items = groupedByPk[pk];

            const hasNonDeleteAction = items.some((item: any) => item.action !== 'delete');
            if (items.length === 0) return null;
            return (
                <div key={pk} className={`history-mapping-group ${items.length === 0 ? '' : 'mb-4'}`}>
                    {<div className='product-history-doc mb-2'>
                        <div className='product-history-title'>
                            <ProductIcon /> <div className={`history-mapping-name`}>{getProductName(pk)}</div>
                        </div>
                        <div>
                            <div className='horizontal-line'>
                            </div>
                        </div>
                    </div>}
                    {items.map((item: any, index: number) => (
                        <div key={index} className="history-mapping increase-padding">
                            <div className="details-div ">
                                {item.action === "delete" && (
                                    <div className="ttile display-set prod-deleted">
                                        This product was removed.
                                    </div>
                                )}
                                {item.fieldName === "subject" && (
                                    <div className="ttile display-set">
                                        Subjects {item.action === 'create' ? 'added' : 'updated'}
                                        <div className="display-detail mb-less">
                                            {item.action === 'upsert' && (
                                                <>
                                                    <span>{getProductSubjectNames(item?.oldValue)}</span>{" -> "}
                                                </>
                                            )}
                                            <span className="pro">{getProductSubjectNames(item?.newValue)}</span>
                                        </div>
                                    </div>
                                )}
                                {item.fieldName === "class" && (
                                    <div className="ttile display-set">
                                        Classes {item.action === 'create' ? 'added' : 'updated'}
                                        <div className="display-detail mb-less">
                                            {item.action === 'upsert' && (
                                                <>
                                                    <span>{getProductClassNames(item?.oldValue)}</span> {"-> "}
                                                </>
                                            )}
                                            <span className="pro">{getProductClassNames(item?.newValue)}</span>
                                        </div>
                                    </div>
                                )}
                                {item.fieldName === "price" && (
                                    <div className="ttile display-set">
                                        Price {item.action === 'create' ? 'added' : 'updated'}
                                        <div className="display-detail mb-less">
                                            {item.action === 'upsert' && (
                                                <>
                                                    <span>{Utils.convertDealSize(Number(item?.oldValue))}</span> {"-> "}
                                                </>
                                            )}
                                            <span className="pro">{Utils.convertDealSize(Number(item?.newValue))}</span>
                                        </div>
                                    </div>
                                )}
                                {item.fieldName === "quantity" && (
                                    <div className="ttile display-set">
                                        Quantity {item.action === 'create' ? 'added' : 'updated'}
                                        <div className="display-detail mb-less">
                                            {item.action === 'upsert' && (
                                                <>
                                                    <span>{item.oldValue}</span> {"-> "}
                                                </>
                                            )}
                                            <span className="pro">{item.newValue}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            );
        });
    };



    const getContent = () => {
        return (
            <div className="view-history-dialog-content">
                {title === 'followUpDate' && <> {historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice().reverse().map((details: any) => {
                    return (<div className='foloow-up-date-panel'>
                        <div className='left-f-panel'>
                            <div className='history-user-name'>
                                { }
                                {details?.updatedBy !== 'xyz' ? getUserName(details?.updatedBy) : selectedFunnel?.assignedUser?.name}
                            </div>
                            <div className='icon-details'>
                                <Calendericon /> <span className='pre'>{details?.oldValue ? Utils.formatAnyDate(details?.oldValue) : ''}</span> {`->`} <span>{details?.newValue ? Utils.formatAnyDate(details?.newValue) : ''}</span>
                            </div>

                        </div>
                        <div className='right-f-panel'>
                            <div className='update-time-history'>
                                {Utils.convertTimestampToTimeFormatWithTime(details?.timestamp)}
                            </div>
                        </div>

                    </div>)
                }) : <div className='no-updated-yet'>No updates yet!</div>}</>}

                {title === 'funnelState' && <>{historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice().reverse().map((details: any) => {
                    return (<div className='foloow-up-date-panel'>
                        <div className='left-f-panel'>
                            <div className='history-user-name'>
                                { }
                                {details?.updatedBy !== 'xyz' ? getUserName(details?.updatedBy) : selectedFunnel?.assignedUser?.name}
                            </div>
                            <div className='icon-details'>
                                <Statusicon /> <span className='pre'>{getStageName(details?.oldValue)}</span> {`->`} <span>{getStageName(details?.newValue)}</span>
                            </div>

                        </div>
                        <div className='right-f-panel'>
                            <div className='update-time-history'>
                                {Utils.convertTimestampToTimeFormatWithTime(details?.timestamp)}
                            </div>
                        </div>

                    </div>)
                }) : <div className='no-updated-yet'>No updates yet!</div>}</>}

                {title === 'coverageDetails' && <>{historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice().reverse().map((details: any) => {
                    return (<div className='foloow-up-date-panel coverage'>
                        <div className='coverage-details-panel'>


                            <div className='left-f-panel-c'>
                                <div className='history-user-name'>
                                    <Coverageicon />
                                    {details?.updatedBy ? getUserName(details?.updatedBy) : selectedFunnel?.assignedUser?.name}
                                </div>


                            </div>
                            <div className='right-f-panel-c'>
                                <div className='update-time-history'>
                                    {Utils.convertTimestampToTimeFormatWithTime(details?.timestamp)}
                                </div>
                            </div>
                        </div>
                        <div className='icon-details-c'>
                            {details?.oldValue ? <><span className='pre'>{details?.oldValue}</span> {`->`} </> : '' } <span className='post'>{details?.newValue}</span>
                        </div>


                    </div>)
                }) : <div className='no-updated-yet'>No updates yet!</div>}</>}

                {title === 'lastCoverageDate' && <> {historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice().reverse().map((details: any) => {
                    return (<div className='foloow-up-date-panel'>
                        <div className='left-f-panel'>
                            <div className='history-user-name'>
                                { }
                                {details?.updatedBy !== 'xyz' ? getUserName(details?.updatedBy) : selectedFunnel?.assignedUser?.name}
                            </div>
                            <div className='icon-details'>
                                <Calendericon /> <span className='pre'>{details?.oldValue ? Utils.formatAnyDate(details?.oldValue) : ''}</span> {`->`} <span>{details?.newValue ? Utils.formatAnyDate(details?.newValue) : ''}</span>
                            </div>

                        </div>
                        <div className='right-f-panel'>
                            <div className='update-time-history'>
                                {Utils.convertTimestampToTimeFormatWithTime(details?.timestamp)}
                            </div>
                        </div>

                    </div>)
                }) : <div className='no-updated-yet'>No updates yet!</div>}</>}

                {title === 'productDetails' && <> {historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice()
                    .sort((a: any, b: any) => new Date(b._at).getTime() - new Date(a._at).getTime()).map((details: any) => {
                        return (
                            <>
                                <div className='history-view-details mb-10'>
                                    <div className='history-div'>
                                        <div className='history-user-name'>
                                            <div className='name-details'>
                                                {details?.updatedBy !== 'xyz' ? getUserName(details?._by) : selectedFunnel?.assignedUser?.name}
                                            </div>
                                            <div className='time-details'>
                                                {Utils.convertTimestampToTimeFormatWithTime(details?._at)}
                                            </div>
                                        </div>
                                        {getProductDetails(details)}
                                    </div>
                                </div>
                            </>

                        )
                    }) : <div className='no-updated-yet'>No updates yet!</div>}</>}

                {title === 'funnelHistory' && <>
                    {historyDetailss && historyDetailss?.length > 0 ? historyDetailss.slice()
                        .sort((a: any, b: any) => new Date(b._at).getTime() - new Date(a._at).getTime()).slice(0, -1).map((details: any) => {
                            return (
                                <>
                                    <div className='history-view-details mb-10'>
                                        <div className='history-div'>
                                            <div className='history-user-name'>
                                                <div className='name-details'>
                                                    {details?.updatedBy !== 'xyz' ? getUserName(details?._by) : selectedFunnel?.assignedUser?.name}
                                                </div>
                                                <div className='time-details'>
                                                    {Utils.convertTimestampToTimeFormatWithTime(details?._at)}
                                                </div>
                                            </div>
                                            <FullHistoryComponent productList={productList} usersListData={usersListData} details={details} selectedFunnel={selectedFunnel}/>
                                        </div>
                                    </div>
                                </>

                            )
                        }) : <div className='no-updated-yet'>No updates yet!</div>}
                </>}

            </div>
        );
    };

    const getTitleDetail = (name?: string) => {
        if (name === 'followUpDate') {
            return 'Follow Up Date'
        } else if (name === 'funnelState') {
            return 'Funnel State'
        } else if (name === 'coverageDetails') {
            return 'Coverage Details'
        } else if (name === 'lastCoverageDate') {
            return 'Last Date Of Coverage'
        } else if (name === 'productDetails') {
            return 'Product'
        } else if (name === 'funnelHistory') {
            return 'Funnel'
        } else {
            return ''
        }
    }
    return (
        <>
            <Modal
                show={open}
                onHide={() => { onClose() }}
                className={`steam-modal-dialog view-history-dialog `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {getTitleDetail(title)} History
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
            </Modal>
        </>
    );
};




export default HistoryDialog;
